export enum PreviousProductField {
    Unknown = 0,
    TruckType = 1,
    DriverName = 2,
    HaulierName = 3,
    PrefixNumber = 4,
    MobileNumber = 5,
    Truck = 6,
    Trailer = 7,
    ContainerNumber = 8,
    NumberOfCompartments = 9,
    SealsNeededAfterLoading = 10,
    TaraWeight = 11,
    MaxWeight = 12,
    CleaningStatus = 13,
    PreviousProductType = 14,
    SizeOfCompartments = 15,
    NumberOfPreviousProducts = 16,
    IDTF = 18,
    EquipmentClass = 19,
    ScopaId = 20,

}